import Vue from 'vue';
import Vuex from 'vuex';

export const OPEN_SIDEBAR = 'OPEN_SIDEBAR';
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR';
export const LOCATION_CHANGE = 'router/ROUTE_CHANGED';
export const WINDOW_RESIZE = 'WINDOW_RESIZE';
export const SAVE_USER = 'SAVE_USER';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    sidebarOpened: false,
    obfuscatorActive: false,
    isMobile: false,
    language: '',
    country: '',
    textFile: '',
    dropDownValue: '',
    isTextLoaded: false,
    showPreview: false,
    showEditor: false,
    refreshTextFile: false,
    uploadText: false,
  },
  mutations: {
    [SAVE_USER](state, payload) {
      state.user = payload;
    },
    [CLOSE_SIDEBAR](state) {
      state.sidebarOpened = false;
      state.obfuscatorActive = false;
    },
    [OPEN_SIDEBAR](state) {
      state.sidebarOpened = true;
      state.obfuscatorActive = true;
    },
    [LOCATION_CHANGE](state) {
      state.sidebarOpened = false;
      state.obfuscatorActive = false;
    },
    [WINDOW_RESIZE](state) {
      const { innerWidth } = window;
      const isMobile = innerWidth > 1024;
      state.isMobile = isMobile;
      state.sidebarOpened = isMobile;
    },
    getLanguage(state, payload) {
      state.language = payload;
    },
    getCountry(state, payload) {
      state.country = payload;
    },
    getTextFile(state, payload) {
      state.textFile = payload;
    },
    getDropdownValue(state, payload) {
      state.dropDownValue = payload;
    },
    isTextLoaded(state, payload) {
      state.isTextLoaded = payload;
    },
    openTextPreview(state, payload) {
      state.showPreview = payload;
    },
    openEditor(state, payload) {
      state.showEditor = payload;
    },
    freshTextFile(state, payload) {
      state.refreshTextFile = payload;
    },
    signalTextUpload(state, payload) {
      state.uploadText = payload;
    },
  },
  actions: {
    openSidebar({ commit }) {
      commit({ type: OPEN_SIDEBAR });
    },
    closeSidebar({ commit }) {
      commit({ type: CLOSE_SIDEBAR });
    },
    handleResize({ commit }) {
      commit({ type: WINDOW_RESIZE });
    },
    saveUser({ commit }, payload) {
      commit({
        type: SAVE_USER,
        userData: payload,
      });
    },
  },
  getters: {
    textFile: state => state.textFile,
    choosenLanguage: state => state.language,
    choosenCountry: state => state.country,
    receivedDropDownValue: state => state.dropDownValue,
    textIsLoaded: state => state.isTextLoaded,
    showPreview: state => state.showPreview,
    showEditor: state => state.showEditor,
    refreshText: state => state.refreshTextFile,
    uploadText: state => state.uploadText,
  },
});
